import ACTIONS from '../actionTypes/team';

const initialState = {
  members: [],
  pendingMembers: [],
  isLoading: false,
  hasError: false,
  inviteUserStatus: {
    isInviting: false,
    hasError: false,
    error: null,
    email: '',
  },
  cancelInviteStatus: {
    isCancellingInvite: false,
    hasError: false,
    userVerification: null,
  },
  removeUserStatus: {
    isRemovingUser: false,
    hasError: false,
    error: null,
    email: '',
  },
};

export default function teams(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.FETCH_TEAM_LIST: {
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    }
    case ACTIONS.FETCH_TEAM_LIST_ERROR:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        error: action.error
      };
    case ACTIONS.FETCH_TEAM_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasError: false,
        members: [...action.payload.allUsers?.members],
        pendingMembers: [...action.payload.allUsers?.pendingMembers],
        error: null,
      };
    case ACTIONS.CLEAR_TEAM_LIST:
      return {
        ...state,
        isLoading: false,
        hasError: false,
        members: [],
        pendingMembers: [],
      };
    case ACTIONS.INVITE_NEW_USER:
      return {
        ...state,
        inviteUserStatus: {
          ...state.inviteUserStatus,
          isInviting: true,
          hasError: false,
          email: action.payload,
        }
      };
    case ACTIONS.INVITE_NEW_USER_SUCCESS:
      return {
        ...state,
        inviteUserStatus: {
          ...state.inviteUserStatus,
          isInviting: false,
          hasError: false,
          error: null,
        }
      };
    case ACTIONS.INVITE_NEW_USER_ERROR:
      return {
        ...state,
        inviteUserStatus: {
          ...state.inviteUserStatus,
          isInviting: false,
          hasError: true,
          error: action.error
        }
      };
    case ACTIONS.INVITE_NEW_USER_RESET_STATE:
      return {
        ...state,
        inviteUserStatus: {
          isInviting: false,
          hasError: false,
          email: '',
        }
      };
    case ACTIONS.CANCEL_USER_INVITE:
      return {
        ...state,
        cancelInviteStatus: {
          ...state.cancelInviteStatus,
          isCancellingInvite: true,
          hasError: false,
          userVerification: action.payload,
        }
      };
    case ACTIONS.CANCEL_USER_INVITE_SUCCESS:
      return {
        ...state,
        cancelInviteStatus: {
          ...state.cancelInviteStatus,
          isCancellingInvite: false,
          hasError: false,
          error: null,
        }
      };
    case ACTIONS.CANCEL_USER_INVITE_ERROR:
      return {
        ...state,
        cancelInviteStatus: {
          ...state.cancelInviteStatus,
          isCancellingInvite: false,
          hasError: true,
          error: action.error
        }
      };
    case ACTIONS.CANCEL_USER_INVITE_RESET_STATE:
      return {
        ...state,
        cancelInviteStatus: {
          isCancellingInvite: false,
          hasError: false,
          error: null,
          userVerification: null,
        }
      };
      


    case ACTIONS.REMOVE_USER:
      return {
        ...state,
        removeUserStatus: {
          ...state.removeUserStatus,
          isRemovingUser: true,
          hasError: false,
          error: null,
          email: '',
        }
      };
    case ACTIONS.REMOVE_USER_SUCCESS:
      return {
        ...state,
        removeUserStatus: {
          ...state.removeUserStatus,
          isRemovingUser: false,
          hasError: false,
          error: null,
          email: '',
        }
      };
    case ACTIONS.REMOVE_USER_ERROR:
      return {
        ...state,
        removeUserStatus: {
          ...state.removeUserStatus,
          isRemovingUser: false,
          hasError: true,
          error: null,
          error: action.error
        }
      };
    case ACTIONS.REMOVE_USER_RESET_STATE:
      return {
        ...state,
        removeUserStatus: {
          isRemovingUser: false,
          hasError: false,
          error: null,
          email: '',
        }
      };
    default:
      return state;
  }
}
